
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Agency } from './agency';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';



@Injectable({
  providedIn: 'root'
})


export class AgencyService {

  baseUrl: string = environment.serviceUrl; 
  constructor(private httpclient: HttpClient) { }

  Get(): Observable<Agency[]> {
    return this.httpclient.get<Agency[]>(this.baseUrl + 'api/agencyapi')

  }
  GetAllDepartments() {
    return this.httpclient.get<Agency[]>(this.baseUrl + 'api/DepartmentApi')
  }
  ValidateAgency(agency) {
    return this.httpclient.get(this.baseUrl + 'api/agencyapi/FindAgencyByName?name=' + agency)
  }
  Post(agency: Agency) {

    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpclient.post(this.baseUrl + 'api/agencyapi/AddAgency', agency, { headers: header, observe: 'response' })

  }
  //http put method
  Put(agency: Agency): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpclient.put<any>(this.baseUrl + 'api/agencyapi/Update', agency,
      { headers: header, observe: 'response' });
  }

  Delete(agency: Agency) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpclient.post(this.baseUrl + 'api/agencyapi/activeordeactive', agency, { headers: header, observe: 'response' })
  }
  getActiveAgencies() {
    return this.httpclient.get<Agency[]>(this.baseUrl + 'api/agencyapi/GetActive');
  }
}
